<template>
    <div class="horizontal-item pa-2">
         <div class="text-center" @click="clickFavoriteItem">
            <v-skeleton-loader v-if="loading" type="avatar" height="80px" width="80px"></v-skeleton-loader>
            <v-avatar v-else size="80px" color="primary">
                <v-icon v-if="!image" class="white--text">{{icon}}</v-icon>
                <v-img max-height="60" v-else :src="image"></v-img>
            </v-avatar>
            <v-skeleton-loader v-if="loading" type="heading" class="horizontal-item-title pt-2"></v-skeleton-loader>
            <div v-else class="horizontal-item-title pt-2" v-html="title"></div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {

    },
    props: {
        title: String,
        icon: String,
        image: String,
        loading: Boolean,
        item: Object
    },
    methods: {
        clickFavoriteItem() {
            this.$emit("click", this.item);
        }
    }
}
</script>
<style>
.horizontal-item-title .v-skeleton-loader__heading {
    margin: 0 auto;
}
.v-skeleton-loader__avatar{
    width: 80px;
    height: 80px;   
}
</style>